module.exports = __webpack_public_path__ + "static/media/eyelet03.cb841fd4.webp";